import React from 'react';
import './FomoOverlay.css';

const FomoOverlay = ({ isVisible, onClose, featureName }) => {
  if (!isVisible) return null;

  return (
    <div className="fomo-overlay">
      <div className="fomo-modal">
        <div className="fomo-header">
          <h3>🔑 Unlock by finishing Setup</h3>
          <button className="fomo-close" onClick={onClose}>×</button>
        </div>
        <div className="fomo-content">
          <div className="fomo-icon">🚀</div>
          <h4>Unlock {featureName}</h4>
          <p>This feature is already available to registered early access users.</p>
          <ul className="fomo-benefits">
            <li>📡 Pre-release setup</li>
            <li>🔬 First Look around</li>
            <li>📰 First to news and updates</li>
            <li>🖋️ Personalized experience</li>
          </ul>
          <div className="fomo-cta">
            <p><strong>Join early adopters that are already inside!</strong></p>
            <p>Complete your verification to unlock everything.</p>
          </div>
        </div>
        <div className="fomo-actions">
          <button className="fomo-primary-btn" onClick={onClose}>
            Complete Verification
          </button>
          <button className="fomo-secondary-btn" onClick={onClose}>
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default FomoOverlay;
